import { ContentCardSlider } from '@desquared/wave-components-library';
import Link from 'next/link';
import { contentCardsAnalyticsFunction } from '@/utils/analytics';
import { useTranslations } from 'use-intl';
import { useIsRtl } from '@/contexts/DirectionContext.jsx';

export default function SliderSection({ style, shape, cards, title, hasPadding, rewind = true }) {
  const t = useTranslations();
  const isRtl = useIsRtl();

  return (
    <ContentCardSlider
      CardsStyle={style}
      shapedCardsShape={shape}
      Cards={cards}
      title={title}
      hasPadding={hasPadding}
      rewind={rewind}
      hideArrows={!rewind}
      LinkComponent={props => {
        return <Link prefetch={false} href={props.href} {...props} />;
      }}
      analyticsFunction={contentCardsAnalyticsFunction}
      imageAltWording={t('product_details.image')}
      isRtl={isRtl}
    />
  );
}
